import Super from 'client-portal/routes/-request/prescreener-administrative';

export default class WidgetPrescreenerAdministrative extends Super {}
